import {IncomingMessage} from 'http'

import {MYASSET_APIS, NeloLoggingBody} from '$constants/api-infos'
import {internalApi} from '$utils/api'

const {POST_NELO_LOGGING} = MYASSET_APIS

export async function sendNeloToBFF(body: NeloLoggingBody, req?: IncomingMessage) {
    const {path, method} = POST_NELO_LOGGING
    const {data} = await internalApi(path, {method, data: body, req})
    return data
}
